import { useMemo } from 'react';
import {
  CERTIFICATION_TYPE_DISPLAY_NAMES,
  INITIAL_CERT_TYPE,
  MOVE_IN_CERT_TYPE,
} from '../../constants/affordableCertificationTypes';
import { RD_PROGRAM_NAME } from '../../constants/affordableProgramNames';
import { COMPLIANCE_TYPES } from './constantsV2';
import { isDocumentReviewOverdue } from './utilsV2';

const useParseResults = ({
  results,
  complianceType,
  complianceSummaryNeedsReviewReviewOverdueColumn,
}) => {
  return useMemo(() => {
    return results.map((result) => {
      const parsedResult = { ...result };
      if (result.hasOwnProperty('isActive')) {
        parsedResult.isActive = Boolean(result.isActive === 'Yes');
      }

      if (result.hasOwnProperty('isResident')) {
        parsedResult.isResident = Boolean(result.isResident === 'Yes');
      }

      if (result.hasOwnProperty('certificationType')) {
        const isRDInitial =
          result.certificationType === MOVE_IN_CERT_TYPE &&
          result.programType === RD_PROGRAM_NAME;

        // RD MOVE_IN is called INITIAL
        if (isRDInitial) {
          parsedResult.certificationType =
            CERTIFICATION_TYPE_DISPLAY_NAMES[INITIAL_CERT_TYPE];
        } else {
          parsedResult.certificationType =
            CERTIFICATION_TYPE_DISPLAY_NAMES[result.certificationType] ??
            result.certificationType;
        }
      }

      if (
        result.hasOwnProperty('complianceApprovalStatus') &&
        result.complianceApprovalStatus === null
      ) {
        parsedResult.complianceApprovalStatus = 'None';
      }

      if (
        result.hasOwnProperty('voucherEffectiveDate') &&
        result.hasOwnProperty('certificationType')
      ) {
        // The backend owns past-due (its recertRange bucket); no client-side
        // date math fallback.
        parsedResult.isPastDue =
          result.recertRange === null || result.recertRange === undefined
            ? null
            : result.recertRange === 'lateRecerts';

        if (
          complianceType === COMPLIANCE_TYPES.NEEDS_REVIEW &&
          complianceSummaryNeedsReviewReviewOverdueColumn
        ) {
          parsedResult.isReviewOverdue = isDocumentReviewOverdue({
            certificationType: result.certificationType,
            complianceApprovalStatus: result.complianceApprovalStatus,
            complianceDocumentType: result.complianceDocumentType,
            uploadDate: result.uploadDate,
          });
        }
      }

      if (result.hasOwnProperty('isReviewed')) {
        if (complianceType === COMPLIANCE_TYPES.NEEDS_REVIEW) {
          parsedResult.isAttentionRequired = undefined;
        } else {
          const isReviewed = Boolean(result.isReviewed);
          const isPastDue = parsedResult.isPastDue;
          parsedResult.isAttentionRequired =
            isPastDue == null ? !isReviewed : !isReviewed && !isPastDue;
        }
      }

      return parsedResult;
    });
  }, [
    complianceType,
    results,
    complianceSummaryNeedsReviewReviewOverdueColumn,
  ]);
};

export default useParseResults;
